import { paginator } from '@/services';

export default {
  containers: paginator()(),
  colunas: [
    {
      text: 'referenciaCliente',
      value: 'REFERENCIA_CLIENTE',
      width: 170,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        module: 'containers',
        fetch: 'fetchContainers',
        colDef: {
          field: 'referenciaCliente',
        },
      },
    },
    {
      text: 'referenciaTrust',
      value: 'REFERENCIA_TRUST',
      width: 155,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        module: 'containers',
        fetch: 'fetchContainers',
        colDef: {
          field: 'referenciaTrust',
        },
      },
    },
    {
      text: 'container',
      value: 'NUMERO_CONTAINER',
      width: 125,
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        module: 'containers',
        fetch: 'fetchContainers',
        colDef: {
          field: 'container',
        },
      },
    },
    {
      text: 'bl',
      value: 'NUMERO_HOUSE',
      filterable: true,
      filterComponent: 'TextFilter',
      isDataTable: true,
      filterParams: {
        module: 'containers',
        fetch: 'fetchContainers',
        colDef: {
          field: 'house',
        },
      },
    },
    {
      text: 'tipoContainer',
      value: 'TIPO_CONTAINER',
      width: 165,
      filterable: true,
      isDataTable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        module: 'containers',
        fetch: 'fetchContainers',
        colDef: {
          field: 'tipoContainer',
        },
      },
    },
    {
      text: 'armador',
      value: 'NOME_ARMADOR',
      width: 145,
      filterable: true,
      isDataTable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        module: 'containers',
        fetch: 'fetchContainers',
        colDef: {
          field: 'armador',
        },
      },
    },
    {
      text: 'lacre',
      value: 'NUMERO_LACRE',
      width: 125,
      filterable: true,
      isDataTable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        module: 'containers',
        fetch: 'fetchContainers',
        colDef: {
          field: 'lacre',
        },
      },
    },
    {
      text: 'dataChegada',
      value: 'DATA_CHEGADA_CONTAINER',
      width: 165,
      filterable: true,
      isDataTable: true,
      filterParams: {
        module: 'containers',
        fetch: 'fetchContainers',
        colDef: {
          field: 'dataChegada',
        },
      },
      filterComponent: 'DateFilter',
    },
    {
      text: 'freetime',
      value: 'FREETIME',
      width: 125,
      filterable: true,
      isDataTable: true,
      filterComponent: 'TextFilter',
      filterParams: {
        module: 'containers',
        fetch: 'fetchContainers',
        colDef: {
          field: 'freetime',
        },
      },
    },
    {
      text: 'vencimentoFreetime',
      value: 'DATA_VENCIMENTO_FREETIME',
      width: 185,
      filterable: true,
      isDataTable: true,
      filterParams: {
        module: 'containers',
        fetch: 'fetchContainers',
        colDef: {
          field: 'vencimentoFreetime',
        },
      },
      filterComponent: 'DateFilter',
    },
    {
      text: 'dataEntrega',
      value: 'DATA_ENTREGA_CONTAINER',
      width: 165,
      filterable: true,
      isDataTable: true,
      filterParams: {
        module: 'containers',
        fetch: 'fetchContainers',
        colDef: {
          field: 'dataEntrega',
        },
      },
      filterComponent: 'DateFilter',
    },
  ],
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    status: '',
    order: 'referenciaTrust',
    direcao: 'DESC',
  },
  excelFiltros: {
    referenciaCliente: '',
    referenciaTrust: '',
    container: '',
    bl: '',
    tipoContainer: '',
    armador: '',
    lacre: '',
    dataChegada: '',
    freetime: '',
    vencimentoFreetime: '',
    dataEntrega: '',
  },
};
